import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasPaymentSchema = withDefaults({
  type: 'tas-payment',
  objectExtensions: ['tas-payment'],
  fields: [
    {
      kind: 'attribute',
      name: 'paymentDate',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'paymentType',
    },
    {
      kind: 'attribute',
      name: 'paymentManner',
    },
    {
      kind: 'attribute',
      name: 'paymentFilePaths',
    },
    {
      kind: 'attribute',
      name: 'reportFilePaths',
    },
    {
      kind: 'attribute',
      name: 'settleFilePath',
    },
    {
      kind: 'attribute',
      name: 'jpmFilePath',
    },
    {
      kind: 'attribute',
      name: 'feeOnly',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'stats',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasPaymentSchema;
